import React, {useEffect, useState} from 'react';
import {getProductGroup} from "../api/HomeApi";
import {BiCategoryAlt} from "react-icons/bi";
import {TiChevronLeftOutline} from "react-icons/ti";
import {IoMdArrowDropleft} from "react-icons/io";
import {useNavigate, useParams} from "react-router-dom";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";
import {LiaChevronLeftSolid, LiaCubesSolid} from "react-icons/lia";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";

const ProductGroups = (props) => {
    const [productGroups, setProductGroups] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [showProducts, setShowProducts] = useState(false);
    const {id} = useParams();
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    useEffect(() => {
        const fetchGroups = async () => {
            try {

                const params = {
                    count: props.showAll ? 80 : config.shopping_app_settings.product_group_count,
                    special: props.showAll ? 0 : 1,
                    list: 1,
                    vendor: localStorage.getItem('_vid') === "1" ? null : localStorage.getItem('_vid'),
                    parent_id : id
                }
                const data = await getProductGroup(params);
                setProductGroups(data?.data || []);
                if (props.showAll && config.shopping_app_settings.show_products_in_groups === "1" ) {
                    if(data?.data[0].products.length) {
                        setShowProducts (true)
                    }
                }
            } catch (err) {
                 showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchGroups();
    }, [id]);



    if (loading) return <Loading />;



    return (

    <section className="container  mt-4  rtl px-0  ">
        { !props.showAll && (
            <div className="row mx-1">
                <div className="col-8 home-separator-text ">
                    <BiCategoryAlt className='mx-2'/>

                    دسته بندی ها
                </div>
                <div className="col-4 text-start text-small-3 text-secondary-color mt-1"
                     onClick={
                         () => {
                             navigate(`/categories`)
                         }
                     }
                >
                    مشاهده همه
                    <TiChevronLeftOutline className='mx-1'/>
                </div>
            </div>
        )

        }

        {
            showProducts ?

                <div className="row mx-2 pb-5 my-3">
                    {
                        productGroups.map(group => {
                            return (
                                <div
                                    className="col-12 px-1 text-center product-group product-group-page mb-5 pb-2"
                                    key={group.id}

                                >
                                    <div className="text-end text-big-1 text-muted mb-4 fw-bold"
                                         onClick={
                                             () => {
                                                 group.sub_categories > 0 ?
                                                     navigate(`/categories/${group.id}`) :
                                                     navigate(`/products/${group.id}`)
                                             }
                                         }
                                    >
                                        <LiaCubesSolid className='ms-2 text-big-2 opacity-75' />
                                        {group.name}
                                        <LiaChevronLeftSolid className='me-2 text-primary-color' />
                                    </div>

                                    <Swiper
                                        modules={[Navigation]}
                                        navigation
                                        spaceBetween={4}     // فاصله بین آیتم‌ها
                                        slidesPerView={2.2}   // بسته به عرض کارت‌ت ممکنه 2.1 یا 3.2 مناسب باشه
                                        breakpoints={{
                                            576: {slidesPerView: 2.5},
                                            768: {slidesPerView: 3.2},
                                            992: {slidesPerView: 4},
                                        }}
                                    >
                                        {group.products.map((product, index) => (
                                            <SwiperSlide key={product.id}>

                                                <div className="row vendor-product bg-transparent m-1 ms-2 "

                                                >
                                                    <div className="col-12 text-center mt-3"
                                                         onClick={
                                                             () => {
                                                                 navigate(`/product/${product.id}`)

                                                             }
                                                         }
                                                    >
                                                        {
                                                            product.vendor_price?.discount_percent > 0 &&
                                                            <div className='discount-percent'>
                                                    <span
                                                        className='badge badge-info badge-pill bg-third-color  text-small-3'>
                                                    {product?.vendor_price?.discount_percent}
                                                        &nbsp;

                                                        %

                                                </span>
                                                            </div>
                                                        }
                                                        <div className="clearfix"></div>
                                                        <img src={product.image} alt={product.name} className='w-50'/>

                                                    </div>
                                                    <div className="col-12 mt-3 text-center text-small-2" onClick={
                                                        () => {
                                                            navigate(`/product/${product.id}`)
                                                        }
                                                    }>
                                                        {product.name.substring(0, 30)}
                                                    </div>

                                                                                       </div>

                                            </SwiperSlide>
                                        ))}
                                    </Swiper>

                                </div>
                            )
                        })

                    }

                </div>
                :

                <div className="row mx-2 pb-5 my-2">
                    {
                        productGroups.map(group => {
                            return (
                                <div
                                    className={props.showAll ? "col-4 col-md-2 px-1 text-center product-group" : "col-3 col-md-2 px-1 text-center product-group"}
                                    key={group.id}
                                    onClick={
                                        () => {
                                            group.sub_categories > 0 ?
                                                navigate(`/categories/${group.id}`) :
                                                navigate(`/products/${group.id}`)
                                        }
                                    }
                                >
                                    <div className="group-image-container">
                                        <img src={group.image} alt={group.name}/>
                                        <div className="title mt-2">

                                            {group.name.substring(0, 14)}
                                            {
                                                group.name.length > 14 ?
                                                    <span className='text-small-4'>
                                                    ...
                                                </span>
                                                    : ''
                                            }
                                            {
                                                group.sub_categories > 0 &&
                                                <span>
                                                <IoMdArrowDropleft/>
                                            </span>
                                            }
                                        </div>
                                    </div>

                                </div>
                            )
                        })

                    }

                </div>
        }


    </section>
    );
};

export default ProductGroups;